function load() {
  return JSON.parse(localStorage.getItem('hd_accounts') || '[]');
}

function save(accounts) {
  localStorage.setItem('hd_accounts', JSON.stringify(accounts));
}

export default {
  namespaced: true,
  state: () => ({
    accounts: load(),
  }),
  mutations: {
    SET_ACCOUNTS(state, accounts) {
      state.accounts = accounts;
      save(accounts);
    },
    ADD_ACCOUNT(state, account) {
      const existing = state.accounts.findIndex(
        a => a.chain === account.chain && a.hdIndex === account.hdIndex
      );
      if (existing >= 0) {
        state.accounts.splice(existing, 1, { ...state.accounts[existing], ...account });
      } else {
        state.accounts.push({ ...account, id: Date.now().toString(), addedAt: Date.now() });
      }
      save(state.accounts);
    },
    DELETE_ACCOUNT(state, id) {
      state.accounts = state.accounts.filter(a => a.id !== id);
      save(state.accounts);
    },
    UPDATE_LABEL(state, { id, label }) {
      const acct = state.accounts.find(a => a.id === id);
      if (acct) { acct.label = label; save(state.accounts); }
    },
  },
  getters: {
    byChain: (state) => (chain) => state.accounts.filter(a => a.chain === chain),
    activeAccount: () => (chain) => {
      const id = localStorage.getItem(`hd_active_${chain}`);
      const accounts = load();
      return accounts.find(a => a.id === id) || null;
    },
  },
};
